<div class="cell field">
    <div class="cell-label" title="{{fieldSettings.label}}">{{fieldSettings.label}}
        <span *ngIf="fieldSettings.isRequired && isZones" class="required-field">*</span>
    </div>

    <div class="flags-icons-container">
        <app-field-level-na-button *ngIf="fieldSettings.showFieldLevelNAButton" [fieldSettings]="fieldSettings"
            [table]="table" [readOnly]="readOnly"></app-field-level-na-button>
        <ziq-calibration-set-attributes-icons *ngIf="!hideAttributeButtons" [attributesFlags]="getAttributesFlags()" class="flags-icons">
        </ziq-calibration-set-attributes-icons>
        <div class="suffix" [ngClass]="{'long-suffix': fieldSettings.isLongMeasurementSection}">
            <zoning-code-attributes *ngIf="!hideAttributeButtons" [identifiers]="identifier" [attributePopupTitleDetails]="fieldSettings.label"></zoning-code-attributes>
            <div [hidden]="!fieldSettings.measurementUnits" class="units"
                [ngClass]="{'long-measurement-block': fieldSettings.isLongMeasurementSection}">
                <span>{{getMeasurementUnitsTitle(fieldSettings.measurementUnits)}}</span>
            </div>
        </div>
    </div>
</div>
